module.exports = __webpack_public_path__ + "img/w_zsx.8bf3beab.png";